import { useCallback } from 'react';
import { replaceUserEndpoint } from '../utils/userEndpoint';
import { patchFriendChallenge, patchHouseholdChallenge } from '../utils/challengeWireApi';

export function challengeHasActions(challenge) {
	return Boolean(
		challenge?.can_accept ||
			challenge?.can_decline ||
			challenge?.can_complete ||
			challenge?.can_fail ||
			challenge?.can_cancel
	);
}

export default function useChallengeActions({ user, csrfToken, endpoints, onAfterAction }) {
	const runAction = useCallback(
		async (challenge, action) => {
			if (!user?.id || !challenge) return;

			const body = action === 'accept' ? { honor_agreed: true } : undefined;

			if (challenge.kind === 'friend') {
				const endpointMap = {
					accept: endpoints.accept_user_fitness_challenge_endpoint,
					decline: endpoints.decline_user_fitness_challenge_endpoint,
					complete: endpoints.complete_user_fitness_challenge_endpoint,
					fail: endpoints.fail_user_fitness_challenge_endpoint,
					cancel: endpoints.cancel_user_fitness_challenge_endpoint
				};
				const url = replaceUserEndpoint(endpointMap[action], { userId: user.id, id: challenge.id });
				await patchFriendChallenge({ endpoint: url, csrfToken, body });
			} else {
				const endpointMap = {
					accept: endpoints.accept_user_fitness_profile_challenge_endpoint,
					decline: endpoints.decline_user_fitness_profile_challenge_endpoint,
					complete: endpoints.complete_user_fitness_profile_challenge_endpoint,
					fail: endpoints.fail_user_fitness_profile_challenge_endpoint,
					cancel: endpoints.cancel_user_fitness_profile_challenge_endpoint
				};
				const url = replaceUserEndpoint(endpointMap[action], { userId: user.id, id: challenge.id });
				await patchHouseholdChallenge({ endpoint: url, csrfToken, body });
			}

			if (onAfterAction) await onAfterAction();
		},
		[user?.id, csrfToken, endpoints, onAfterAction]
	);

	return { runAction };
}
